import { appConstants } from '../../../constants'

const initialState = {
  dataPopular: [],
  loading: false,
  error: null
}

export const reducerPopular = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.GET_POPULAR_SUCCESS :
      return {
        ...state,
        loading: false,
        error: null,
        dataPopular: [...action.payload.popular]
      }
    case appConstants.GET_POPULAR_REQUEST :
      return {
        ...state,
        loading: !state.loading
      }
    case appConstants.GET_POPULAR_FAILED : 
      return {
        ...state,
        error: { ...action.payload.message }
      }
    default:
      return state
  }
}
